<template>
  <div>
    <section>
      <div class="container">
        <div class="row justify-content-center">

          <div class="col-lg-7 text-center mb-5">
            <h2>LIFESTYLE ARTICLES</h2>
            <p>Immerse yourself in the art of indulgence, where luxury living takes centre stage.<br> Discover secluded
              holiday destinations, exquisite wines, the finest restaurants, private events, flawless interior decorating,
              inspiring landscaping designs and more. Embrace the extraordinary and delve into a lavish lifestyle.</p>
          </div>

          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">
                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/luxwaterkloof" style="text-decoration: none;" class="d-block">
                    <img src="/images/lifestyle/luxwaterkloof.jpg" style="border-bottom-right-radius: 30px;"
                      class="mw-100" alt="Featured Blog" /></a>
                  </div>
                </div>
                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">
                  <a href="/article/digital-wealth" style="text-decoration: none;" class="d-block">
                  <h2 class="text-start text-uppercase"><strong>
                  The Pretoria suburb where diplomacy and luxury living converge
                   </strong></h2>
                        </a>

                        <p class="blog-text">
                       The recent record sale of a home in Waterkloof for R30m has put the spotlight back on a suburb that is one of Pretoria's real estate jewels.
                       <br><br>
                        The property, a beautifully renovated six-bedroom, six-bathroom residence on a 2500sqm stand in sought-after Edward Street, was sold by two of Chas Everitt’s dedicated area specialists and reflects the strong demand for premium homes in one of South Africa's most established luxury residential enclaves.
                        </p>
                </div>
              </div>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" href="/article/luxwaterkloof"
              id="lifestyle-cta">READ MORE</a>
          </div>
          
          

             <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">
                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/luxcapetown" class="d-block"><img src="/images/lifestyle/luxcapetown.jpg" style="border-bottom-right-radius: 30px;"
                      class="mw-100" alt="Featured Blog"/></a>
                  </div>
                </div>
                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">
                  <a href="/article/luxcapetown" style="text-decoration: none;" class="d-block">
                   <h2 class="text-start text-uppercase"><strong>
                   Living large in the vibrant heart of Cape Town
                   </strong></h2>
                        </a>
                        <p class="blog-text">
                       For diplomats, international executives and foreign investors exploring South Africa, Cape Town’s central city area offers an enticing combination of cosmopolitan energy, natural beauty and strong property fundamentals that very few global destinations can rival.<br><br>
                       Repeatedly named among the world’s best cities by international travel and lifestyle publications, Cape Town continues to strengthen its reputation not only as a tourism destination but also as a highly attractive place to live, work and invest. This appeal is increasingly reflected in its property market, with values having risen by an average of 9,1% in the past year.
                        </p>
                </div>
              </div>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" href="/article/luxcapetown"
              id="lifestyle-cta">READ MORE</a>
          </div>


          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">
                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/luxconstantia" style="text-decoration: none;" class="d-block"><img src="/images/lifestyle/luxconstantia.jpg" style="border-bottom-right-radius: 30px;"
                      class="mw-100" alt="Featured Blog"/></a>
                  </div>
                </div>
                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">
                  <a href="/article/going-global" style="text-decoration: none;" class="d-block">
                  <h2 class="text-start text-uppercase"><strong>
                  The quiet affluence of Cape Town’s most gracious suburbs
                  </strong></h2></a>
                  <p>
                  In an age of flashy penthouses and ultra-modern beachfront villas, Cape Town’s most enduring luxury addresses remain quietly understated.
                  <br><br> Tucked beneath the eastern slopes of Table Mountain, the leafy suburbs of Bishopscourt, Constantia and Newlands have long represented a different kind of prestige; one rooted not in spectacle, but in heritage, privacy and permanence
                  </p>
                </div>
              </div>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" href="/article/luxconstantia"
              id="lifestyle-cta">READ MORE</a>
          </div>

          

        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  data() {
    return {
      property: {

      }
    };
  },
};
</script>